import React from 'react';
import { useBookingContext } from '../../context/BookingContext';

const ConfirmationDialogue = ({closeCallback}) => {

    const { booking, acceptBooking } = useBookingContext();

    const handleConfirm = () => {
        acceptBooking(booking.id);
    }

    return (
        <div className="w-96 h-16">
            <div className="text-center">Confirm your acceptance of the booking</div>
            <div className="w-48 mx-auto">
                <button className="btn-blue btn-blue-active inline" onClick={handleConfirm}>Confirm</button>
                <button className="btn-blue btn-blue-active inline" onClick={closeCallback}>Close</button>
            </div>
        </div>
    )
}

export default ConfirmationDialogue;
